import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  items: [], // Array to hold cart items
  total: 0, // Total price of items in cart
};

const cartSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    // Add item to cart
    addItemToCart(state, action) {
      const { id, quantity } = action.payload;
      const existingItem = state.items.find((item) => item.id === id);
      if (existingItem) {
        existingItem.quantity += quantity;
      } else {
        state.items.push({ ...action.payload });
      }
    },

    // Remove item from cart
    removeItemFromCart(state, action) {
      const itemId = action.payload;
      const itemToRemove = state.items.find(item => item.id === itemId);

      if (itemToRemove) {
        if (itemToRemove.quantity === 1) {
          state.items = state.items.filter(item => item.id !== itemId);
        } else {
          itemToRemove.quantity--;
        }
        state.total -= itemToRemove.price;
      }
    },

    // Update item quantity in cart
    updateItemQuantity(state, action) {
      const { itemId, quantity } = action.payload;
      const itemToUpdate = state.items.find(item => item.id === itemId);

      if (itemToUpdate) {
        const prevQuantity = itemToUpdate.quantity;
        itemToUpdate.quantity = quantity;
        state.total += (quantity - prevQuantity) * itemToUpdate.price;
      }
    },

    // Clear the entire cart
    clearCart(state) {
      state.items = [];
      state.total = 0;
    },
  },
});

export const selectCartSubtotal = (state) => {
  return state.cart.items.reduce((subtotal, item) => {
    return subtotal + item.price * item.quantity;
  }, 0);
};

// Export action creators
export const { addItemToCart, removeItemFromCart, updateItemQuantity, clearCart } = cartSlice.actions;

// Selectors
export const selectCartItems = state => state.cart.items;
export const selectCartTotal = state => state.cart.total;

// Export reducer
export default cartSlice.reducer;
